import * as FormRecord from "./form-record.js";
import * as FormUtil from "../common/form-util.js";
import * as Chats from "./chats.js";
import * as Layout from "../layout/layout.js";

import * as Searchbar from "../components/searchbar.js";
import * as LoadingDialog from "../components/loading-dialog.js";

import SimpleBar from "simplebar";
import ResizeObserver from "resize-observer-polyfill";

/**
 * Create an object with properties that should be available in the global scope. These
 * are usually used by XHTML pages.
 * @returns Properties to add to global user portal scope.
 */
export function createGlobalPagesExports() {
  return {
    Pages: {
      FormRecord,
      Chats,
    },
  };
}

export function createGlobalSimplebarExports() {
  return {
    SimpleBar: {
      SimpleBar,
      ResizeObserver,
    },
  };
}

export function createGlobalLayoutExports() {
  return {
    Layout,
  };
}

export function createGlobalComponentsExports() {
  return {
    Components: {
      Searchbar,
      LoadingDialog,
    },
  };
}

export function createFormUtilExports() {
  return {
    FormUtil,
  };
}
